<template>
  <div class="page-content">
    <div class="card row">
      <Whatsapp v-if="activeChannel.type === 'whatsapp'"/>
      <Whatsapp_personal v-if="activeChannel.type === 'whatsapp_personal'"/>
      <Sms v-if="activeChannel.type === 'sms'"/>
      <email v-if="activeChannel.type === 'email'" />
      <FB_Messenger v-if="activeChannel.type === 'fb_messenger'"/>
    </div>
  </div>
</template>
<script>
import Whatsapp from '../../components/create-template/Whatsapp.vue';
import Whatsapp_personal from '../../components/create-template/WhatsappPersonal.vue';
import Sms from '../../components/create-template/Sms.vue';
// import email from '@ui/components/create-template/Email.vue';
import email from '../../components/create-template/Email.vue';
import FB_Messenger from '../../components/create-template/FB_Messenger.vue';

export default {
  name: 'CreateTemplate',
  metaInfo: {
    title: 'Create Template',
  },
  components: {
    Whatsapp,
    Whatsapp_personal,
    Sms,
    email,
    FB_Messenger,
  },
  computed: {
    activeChannel() {
      return this.$store.state.channels.activeChannel;
    },
  },
};
</script>
